<script setup>
import { ref } from 'vue';

const emit = defineEmits(['update:modelValue', 'update:focused']);
defineProps({
    hideLabel: {
        type: Boolean,
        default: false
    }
});

const selected = ref(null);
const statuses = [
    { title: 1728, value: 1728 },
    { title: 121416, value: 121416 },
    { title: 1000000, value: 1000000 },
    { title: 28316.847, value: 28316.847 },
    { title: 0.028312570781427, value: 0.028312570781427 },
    { title: 61025.57, value: 61025.57 },
    { title: 128360, value: 128360 },
    { title: 3636.3636, value: 3636.3636 }
];
</script>

<template>
    <v-select
        v-model="selected"
        :items="statuses"
        :label="hideLabel ? '' : $t('Dimensional Factor')"
        density="compact"
        hide-details
        clearable
        persistent-clear
        @update:modelValue="emit('update:modelValue', selected)"
        @update:focused="(state) => emit('update:focused', state)"
    >
        <template v-if="$slots.prepend" v-slot:prepend>
            <slot name="prepend"></slot>
        </template>
    </v-select>
</template>
